export default __webpack_public_path__ + "static/media/room-geleia-real-2.7ef178ee.jpg";